module.exports = __webpack_public_path__ + "img/first-charge-double.387da97a.png";